import { Component, computed, inject, input, Signal } from '@angular/core';
import { TawkToService } from '@core/services/tawk-to.service';
import { fakeAsset } from '@features/contentful/helpers/assetHelpers';
import { AssetImageConfiguration } from '@features/lazy-image/components/lazy-asset-lazy/lazy-asset-lazy.component';
import { LazyAssetComponent } from '@features/lazy-image/components/lazy-asset/lazy-asset.component';
import {
    Configurations,
    LazyPictureComponent,
    Stops,
} from '@features/lazy-image/components/lazy-picture/lazy-picture.component';
import { CallToAction } from '@generated/graphql';
import { CtaButtonComponent } from '@shared/cta-button/cta-button.component';

@Component({
    selector: 'app-knowledge-cta',
    standalone: true,
    imports: [CtaButtonComponent, LazyAssetComponent, LazyPictureComponent],
    templateUrl: './knowledge-cta.component.html',
    styles: ``,
})
export class KnowledgeCtaComponent {
    private tawktoService = inject(TawkToService);

    entry = input.required<CallToAction>();

    featuredImageConfigurationChat: Signal<AssetImageConfiguration> = computed(
        () => ({
            image: this.entry().image,
            ratioWidth: 1,
            ratioHeight: 1,
            width: 120,
            widht2x: 240,
        })
    );

    featuredImageConfigurationLink: Signal<Configurations> = computed(() => ({
        [Stops.FALLBACK]: {
            image: this.entry().image,
            ratioHeight: 1,
            ratioWidth: 1,
            width: 400,
            width2x: 600,
            width3x: 800,
        },
        [Stops.BASE]: {
            image: this.entry().image,
            ratioHeight: 9,
            ratioWidth: 12,
            width: 400,
            width2x: 600,
            width3x: 800,
        },
        [Stops.SM]: {
            image: this.entry().image,
            ratioHeight: 9,
            ratioWidth: 12,
            width: 400,
            width2x: 600,
            width3x: 800,
        },
        [Stops.MD]: {
            image: this.entry().image,
            ratioHeight: 3,
            ratioWidth: 1,
            width: 400,
            width2x: 600,
            width3x: 800,
        },
        [Stops.LG]: {
            image: this.entry().image,
            ratioHeight: 2,
            ratioWidth: 1,
            width: 400,
            width2x: 600,
            width3x: 800,
        },
        [Stops.XL]: {
            image: this.entry().image,
            ratioHeight: 4,
            ratioWidth: 3,
            width: 400,
            width2x: 600,
            width3x: 800,
        },
        [Stops.XXL]: {
            image: this.entry().image,
            ratioHeight: 3,
            ratioWidth: 4,
            width: 400,
            width2x: 600,
            width3x: 800,
        },
    }));

    dialogBubbleImage: AssetImageConfiguration = {
        image: fakeAsset('assets/images/dialog_new.svg', 'Dialog bubble'),
        width: 100,
    };

    openChat() {
        this.tawktoService.open();
    }
}
